module.exports = __webpack_public_path__ + "static/ban_m.f57bd561.jpg";